import { connect } from 'react-redux';
import View from './SectionSidebarView';
import { linksSelector, sectionTitleSelector } from './SectionSidebarSelector';
import withContextualSidebar from '../ContextualSidebarContainer';

const mapStateToProps = (state, ownProps) => ({
  links: linksSelector(state, ownProps),
  sectionTitle: sectionTitleSelector(state, ownProps),
});

const mapDispatchToProps = () => ({
  onLinkClick: (controller, params) => window.ADV.util.Router.go2(controller, params),
});

export default withContextualSidebar(connect(mapStateToProps, mapDispatchToProps)(View));
